import { render, staticRenderFns } from "./addLecturer.vue?vue&type=template&id=e1eef14e&scoped=true"
import script from "./addLecturer.vue?vue&type=script&lang=js"
export * from "./addLecturer.vue?vue&type=script&lang=js"
import style0 from "./addLecturer.vue?vue&type=style&index=0&id=e1eef14e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1eef14e",
  null
  
)

export default component.exports